import type { PaletteModel } from '../../data/types';
import type { ShipColors } from './shipGeometry';
import { PENNANT_COLOURS } from './pennantColours';

/** Open holds use the painting's shade tone; the working lighter shares the fleet's timber palette. */
export function shipColors(palette: PaletteModel): ShipColors {
  return {
    hull: palette.shipHull.median.linear,
    wale: palette.shipHull.p90.linear,
    rail: palette.highlightWhite.median.linear,
    port: palette.shipHull.p10.linear,
    openHull: palette.shipHull.p10.linear,
    rigging: palette.lineworkDark.median.linear,
    sail: palette.sail.median.linear,
    pennants: PENNANT_COLOURS,
    smoke: palette.gunSmoke.median.linear,
  };
}
